const getDocumentType = (documentName) => {
  const indexOfDot = documentName.lastIndexOf('.');
  return indexOfDot === -1 ? "" : documentName.substring(indexOfDot + 1);
};
export default getDocumentType;